import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AngularEditorConfig} from '@kolkov/angular-editor';

export const defaultConfig: AngularEditorConfig = {
  editable: true,
  spellcheck: false,
  toolbarPosition: 'bottom',
  sanitize: false,
  toolbarHiddenButtons: [
    [
      'fontSize',
      'customClasses',
      'insertImage',
      'insertVideo'
    ]
  ]
};

@Component({
  selector: 'app-html-editor',
  templateUrl: './html-editor.component.html'
})
export class HtmlEditorComponent {
  @Input() public config: AngularEditorConfig = defaultConfig;
  @Input() public valid: boolean = true;
  @Input() public placeholder: string;
  @Input() public hint: string;
  @Input() public alternativeHint: string;
  @Input() public error: string;
  @Input() public id: string;
  @Input() public disabled: boolean;

  private _model: any;
  @Input() public set model(value: any) {
    this._model = value;
    this.modelChange.emit(value);
  }
  public get model(): any {
    return this._model;
  }
  @Output() public modelChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() public modelChanged: EventEmitter<any> = new EventEmitter<any>();

  public editorFocused: boolean;

  constructor() {
    if (this.disabled) {
      this.config.editable = false;
    }
  }

}
